export default __webpack_public_path__ + "static/media/background-contact.ba570ef0.jpg";